
import React from "react";
import { 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, 
  Tooltip, ResponsiveContainer, Cell
} from "recharts";
import { GlassCard, GlassCardContent, GlassCardHeader, GlassCardTitle, GlassCardDescription } from "@/components/ui/glass-card";

export function DevicesByDepartment() {
  // Define various shades of purple
  const purpleColors = {
    light: '#A5B4FC',  // Light Purple
    medium: '#818CF8', // Medium Purple
    primary: '#6366F1', // Primary Purple
    dark: '#4F46E5',   // Dark Purple
    deeper: '#4338CA',  // Deeper Purple
  };
  
  // Mock data for departments with our purple color palette
  const data = [
    { name: "Engineering", devices: 24, color: purpleColors.primary },
    { name: "Marketing", devices: 12, color: purpleColors.light },
    { name: "Sales", devices: 18, color: purpleColors.medium },
    { name: "Finance", devices: 9, color: purpleColors.dark },
    { name: "HR", devices: 7, color: purpleColors.deeper },
  ];

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 shadow-md rounded-md border border-gray-100">
          <p className="font-medium text-sm font-poppins">{`${label}`}</p>
          <p className="text-sm font-poppins">{`Devices: ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <GlassCard variant="default">
      <GlassCardHeader className="pb-2">
        <GlassCardTitle className="text-lg font-medium">Devices by Department</GlassCardTitle>
        <GlassCardDescription>Distribution of managed devices across company departments</GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="pt-0">
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data}
              margin={{ top: 20, right: 10, left: 10, bottom: 40 }}
              barSize={35}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E0E0E0" vertical={false} />
              <XAxis 
                dataKey="name" 
                tick={{ fontFamily: 'Poppins, sans-serif', fontSize: 11, fill: "#333333" }}
                axisLine={{ stroke: '#E0E0E0' }}
                tickLine={false}
                angle={0}
                textAnchor="middle"
                interval={0}
                height={45}
              />
              <YAxis 
                tick={{ fontFamily: 'Poppins, sans-serif', fontSize: 11, fill: "#333333" }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }} />
              <Bar 
                dataKey="devices" 
                name="Devices" 
                radius={[4, 4, 0, 0]}
                animationDuration={1500}
              >
                {data.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={entry.color} 
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
